import React, { useContext, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { fetchGetPlanNames } from 'gqlQueries/promoRecommendation';
import { getAuthUser } from 'utils/helperMethods';

const errorMessage: string = 'Something went wrong!';

export const newPlanValue = 'newPlanPR';
export const newPlanObject = {
    value: 'newPlanPR',
    label: 'New Plan',
    planId: 0,
    dim2AttributeName: '',
    saveType: null,
    dim1AttributeName: null,
};
function useFetchGetPlans() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>([]);
    const [tableData, setTableData] = useState<any | null>([]);

    //To fetch dim
    const [fetchPlan, { data: planData, loading: planLoading, error: planError }] = useLazyQuery(fetchGetPlanNames, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
        fetchPolicy: 'cache-and-network',
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            let list: any[] = [];
            list.push({ ...newPlanObject });
            payload.getPlanNames.plansList.forEach((plan: any) => {
                list.push({
                    value: plan.planName,
                    label: plan.planName,
                    ...plan,
                });
            });
            const tableData = payload.getPlanNames.plansList.map((plan: any, index: number) => {
                return {
                    optimized_status: plan.optimizationStatus,
                    plan_name: plan.planName,
                    dim2_name: plan.dim2AttributeName,
                    created_by: plan?.createdBy,
                    created_at: plan.modifiedOn,
                    planId: plan.planId,
                    linked_pricing_scenario: plan.scenarioName,
                    key: plan.planId,
                    value: plan.planName,
                    dropdownData: list?.[index + 1] ?? {},
                };
            });
            setTableData(tableData);
            setData(list);
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData([]);
        setTableData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        tableData,
        fetchPlan: (variables: any) => {
            setData([]);
            setError(null);
            setLoading(true);
            fetchPlan(variables);
        },
    };
}

export default useFetchGetPlans;
